<template>
    <form>
    <div class = "changePasswordModal__container">
      <div class = "changePasswordModal__container__group">
        <LabelComponent class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        label_text = "После изменения имени и фамилии просто обновите страницу для продолжения работы."/>

        <LabelComponent v-if="this.success === true"
                        class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        style="color: green;"
                        label_text = "Имя и фамилия успешно изменены. Перезагрузите страницу"/>
        <LabelComponent v-if="this.success !== null && this.success !== true"
                        class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        style="color: red;"
                        :label_text="this.success"/>
        <LabelComponent class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        label_text = "Новое имя пользователя"/>
        <!-- <LabelComponent v-if="this.oldPassIsNotCorrect"
                        class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        style="color: red;"
                        label_text = "Старый пароль неверный!"/> -->
        <InputField class = "changePasswordModal__container__input"
                    type = "text"
                    label_text = "Имя"
                    :set_values="this.firstName"
                    autocomplete="off"
                    @input_change="(newVal) => {this.firstName = newVal; this.oldPassIsNotCorrect = false;}"
                    />
      </div>
      <div class = "changePasswordModal__container__group">
        <LabelComponent class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        label_text = "Новая фамилия пользователя"/>
        <InputField class = "changePasswordModal__container__input"
                    type = "text"
                    label_text = "Фамилия"
                    autocomplete="off"
                    :set_values="this.lastName"
                    @input_change="(newVal) => {this.lastName = newVal; this.notEqualPasswords = false;}"
                    />
      </div>
      <ButtonComponent class = "changePasswordModal__container__button"
                       label = "Изменить"
                       elementType = "default-bg"
                       :elementInLoading="this.requesting"
                       :elementStatusModifier="this.requesting ? 'disabled' : null"
                       @click_to_button="this.changeRequest" />
    </div>
  </form>
</template>

<script>

import LabelComponent from '@/units/RichLabel.vue';
import ButtonComponent from '@/units/forms/RichButton.vue';
import InputField from '@/units/forms/InputField.vue';

// import {changePasswordRequest} from '@/assets/dataSources/auth/changePasswordRequest';
import {changeLoginRequest} from '@/assets/dataSources/auth/changeLoginRequest';

export default {
  components: {
    LabelComponent,
    ButtonComponent,
    InputField,
  },
  data: () => ({
    firstName: '',
    lastName: '',
    confirmPass: '',
    requesting: false,
    notEqualPasswords: false,
    oldPassIsNotCorrect: false,
    success: null,
  }),
  methods: {
    changeRequest() {
      // if (this.requesting) {
      //   return;
      // }

      this.success = null;

      // if (this.lastName != this.confirmPass) {
      //   this.notEqualPasswords = true;
      //   return;
      // }

      this.requesting = true;

      const curThis = this;

      changeLoginRequest(this.firstName, this.lastName).then(async function(response) {
        curThis.requesting = false;

        if (response.status == 200) {
          curThis.success = true;
          curThis.firstName = '';
          curThis.lastName = '';
          curThis.confirmPass = '';
          return;
        }

        // if (response.status == 403) {
        //   curThis.success = 'Неверный старый пароль!';
        //   curThis.firstName = '';
        //   curThis.lastName = '';
        //   curThis.confirmPass = '';
        //   return;
        // }

        if (response.status == 400) {
          const respText = await response.text();

          curThis.success = 'Имя, фамилия не соответствуют требованиям безопасности!\r\n\r\n' + respText;
          curThis.lastName = '';
          curThis.confirmPass = '';
          return;
        }

        if (response.status == 401) {
          curThis.success = 'Вы неавторизованы!';
          curThis.firstName = '';
          curThis.lastName = '';
          curThis.confirmPass = '';
          return;
        }

        // console.log('response', response);

        const respText = await response.text();

        curThis.success = String(response.status) + ' ' + respText;
      }).catch(function() {
        curThis.requesting = false;
        curThis.success = 'Ошибка связи с сервером! Попробуйте обновить страницу.';
      });
    },
  },
};
</script>

<style lang="less">
.changePasswordModal {
  &__container {
    min-width: 250px;
    width: 15vw;
    display: grid;
    grid-row-gap: 20px;

    &__group {
      display: grid;
      grid-row-gap: 10px;
    }
    &__input {
      width: 100%;
    }
  }

}
</style>
